export default "__VITE_ASSET__BJHi3dLb__"